import { createReducer, on } from '@ngrx/store';
import {
  AttributeNameChanged,
  AttributeTypeChanged,
  ButtonPointerEventDisabled,
  ButtonPointerEventEnabled,
  DropZoneDisabled,
  DropZoneEnabled,
  EmailChanged,
  FileNameChanged,
  FileNotSupported,
  FileToUploadChanged,
  GetFile,
  ListNotesChanged,
  ListTypeChanged,
  NameChanged,
  RemoveFile,
  SubmitNewListData,
  TargetChanged,
  UploadedFileChanged,
} from '../actions/create-new-list.actions';
import { GetAttributeCodesSuccess, GetTargetsSuccess } from '../actions/lists.actions';
import { CloseSidenav } from '../actions/sidenav.actions';
import { ListAttributeType, ListTypes, ListTypesEnum, Target } from '../models/lists.model';

export interface CreateNewListState {
  name: string;
  listType: string;
  target: string;
  listNotes: string;
  listTypes: ListTypes;
  targets: string[];
  buttonEventsDisabled: boolean;
  enteredDropZone: boolean;
  uploadedFile: { name: string; size: number };
  file: any;
  fileName: string;
  fileNotSupported: boolean;
  fileToUpload: any;
  email: string;
  isSubmittedData: boolean;
  attributesData: any[];
  attributeNames: string[];
  attributeTypes: ListAttributeType;
  attributeType: string;
  attributeName: string;
}

const initialState: CreateNewListState = {
  name: '',
  listType: '',
  target: '',
  listNotes: '',
  listTypes: {
    Empty: 'EMPTY',
    IDs: 'IDS',
    LoyaltyCards: 'LOYALTYCARDS',
    Attributes: 'STRING_ATTRIBUTES',
  },
  targets: [],
  buttonEventsDisabled: false,
  enteredDropZone: false,
  uploadedFile: { name: '', size: 0 },
  file: '',
  fileName: '',
  fileNotSupported: false,
  fileToUpload: '',
  email: '',
  isSubmittedData: false,
  attributesData: [],
  attributeNames: [],
  attributeTypes: {
    String: 'STRING',
  },
  attributeType: '',
  attributeName: '',
};

export const CreateNewListReducer = createReducer(
  initialState,
  on(NameChanged, (state, { name }) => ({
    ...state,
    name,
  })),
  on(ListTypeChanged, (state, { listType }) => ({
    ...state,
    listType,
    target: listType === ListTypesEnum.LOYALTY_CARDS ? Target.LOYALTY_MEMBER : state.target,
    attributeName: '',
    attributeType: '',
    attributeNames: [],
  })),
  on(TargetChanged, (state, { target }) => ({
    ...state,
    target,
    attributeName: '',
    attributeType: '',
    attributeNames: [],
  })),
  on(ListNotesChanged, (state, { listNotes }) => ({
    ...state,
    listNotes,
  })),
  on(GetTargetsSuccess, (state, { res }) => ({
    ...state,
    targets: res.campaignSelectionTargetEnum.filter(
      (item: string) => item === Target.LOYALTY_MEMBER || item === Target.PERSON,
    ),
  })),
  on(DropZoneEnabled, (state) => ({
    ...state,
    enteredDropZone: true,
  })),
  on(DropZoneDisabled, (state) => ({
    ...state,
    enteredDropZone: false,
  })),
  on(ButtonPointerEventEnabled, (state) => ({
    ...state,
    buttonEventsDisabled: false,
  })),
  on(ButtonPointerEventDisabled, (state) => ({
    ...state,
    buttonEventsDisabled: true,
  })),
  on(GetFile, (state, { file }) => ({
    ...state,
    file,
  })),
  on(RemoveFile, (state) => ({
    ...state,
    file: '',
    uploadedFile: { name: '', size: 0 },
    fileNotSupported: false,
  })),
  on(FileNameChanged, (state, { fileName }) => ({
    ...state,
    fileName,
  })),
  on(FileNotSupported, (state) => ({
    ...state,
    fileNotSupported: true,
  })),
  on(UploadedFileChanged, (state, { name, size }) => ({
    ...state,
    uploadedFile: { name: name, size: size },
  })),
  on(FileToUploadChanged, (state, { fileToUpload }) => ({
    ...state,
    fileToUpload,
  })),
  on(EmailChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    name: '',
    listType: '',
    target: '',
    listNotes: '',
    buttonEventsDisabled: false,
    enteredDropZone: false,
    uploadedFile: { name: '', size: 0 },
    file: '',
    fileName: '',
    fileToUpload: '',
    email: '',
    isSubmittedData: false,
    attributeType: '',
    attributeName: '',
    attributeNames: [],
    fileNotSupported: false,
  })),
  on(SubmitNewListData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(GetAttributeCodesSuccess, (state, { res }) => ({
    ...state,
    attributesData: res,
  })),
  on(AttributeTypeChanged, (state, { attributeType }) => {
    let entityTypeFilter = '';

    if (state.target === Target.LOYALTY_MEMBER) {
      entityTypeFilter = 'LOYALTY_MEMBER';
    } else if (state.target === Target.PERSON) {
      entityTypeFilter = 'CUSTOMER';
    }

    return {
      ...state,
      attributeType,
      attributeNames: state.attributesData
        .filter((x) => x.entityType === entityTypeFilter)
        .flatMap((x) =>
          x.attributeCodes.filter((a: any) => a.attributeType === attributeType).flatMap((a: any) => a.attributeNames),
        ),
    };
  }),
  on(AttributeNameChanged, (state, { attributeName }) => ({
    ...state,
    attributeName,
  })),
);
